export class PresentLoader {
  public static readonly type = '[Loader] PresentLoader';
}
